window.global = window.global || {};
window.o_global = window.o_global || {};
window.o_util = window.o_util || {};
window.o_tracking = window.o_tracking || {};

global.hashTracking = (function() {
    "use strict";

    var TRACKING_CLASS = ".js_tracking",
        track = false,
        isAlreadyInitialized = false;

    /**
     * Sends data to the tracking server.
     *
     * @param {Object} dataContainer    The data to be send to the tracking server.
     * @param {Boolean} nonHidden       Hidden
     */
    function sendData(dataContainer, nonHidden) {
        if (nonHidden) {
            o_util.core.extend(dataContainer, {
                "ns_type": ""
            });
        }

        try {
            o_tracking.bct.sendMergeToTrackingServer(dataContainer);
        } catch (err) {
            console.log("no connection to tracking Server");
        }
    }

    /**
     * Tracks the hash.
     */
    function hashTrack() {
        var domList = document.querySelectorAll(TRACKING_CLASS),
            trackingHash,
            t;

        track = o_util.core.toArray(domList).some(function(element) {
            return element.hasAttribute("data-track");
        });

        if (track) {
            trackingHash = o_util.fragment.get("t");
            try {
                if (trackingHash) {
                    t = JSON.parse(trackingHash);
                    if (t) {
                        sendData(t);

                        o_util.fragment.remove("t");

                        if ((window.location.hash === "" || window.location.hash === "#") && history.replaceState) {
                            history.replaceState("", document.title, window.location.href.replace(/#$/, ""));
                        }
                    }
                }
            } catch (ignore) {
            }
        }
    }

    /**
     * Inits the hashtracking.
     *
     * @param {Boolean} isTesting   true, if it was called by a test.
     */
    function init(isTesting) {
        if (!isAlreadyInitialized || isTesting) {
            hashTrack();
        }

        isAlreadyInitialized = true;
    }

    return {
        "init": init,
        "hashTrack": hashTrack
    };
}());

o_global.eventLoader.onLoad(100, function() {
    "use strict";

    global.hashTracking.init();
});
